<div class="pb-6 text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>

@if (subscription(); as sub) {
  <div class="flex flex-col gap-6 w-full">
    <aura-user-subscription-card
      [planName]="planName()"
      [status]="sub.status"
      [cancelAtPeriodEnd]="sub.cancelAtPeriodEnd"
      [currentPeriodStart]="sub.currentPeriodStart"
      [currentPeriodEnd]="sub.currentPeriodEnd"
    />

    @if (!isSubscribed()) {
      <div class="mt-4 flex flex-col gap-4">
        <h3 class="text-xl font-bold text-neutral-12">Renouveler mon abonnement</h3>
        <div class="border border-neutral-a4 rounded-2xl p-4 sm:p-6 bg-neutral-1 shadow-sm">
          <aura-stripe-pricing-table></aura-stripe-pricing-table>
        </div>
      </div>
    }

    <aura-user-subscription-portal-card [loadingPortal]="loadingPortal()" (manage)="manageSubscription()" />

    <aura-user-subscription-history
      [history]="history()"
      [loading]="loadingHistory()"
      [loadingMore]="loadingMore()"
      [hasMore]="hasMore()"
      [total]="total()"
      (loadMore)="loadMoreHistory()"
    />
  </div>
} @else {
  <div class="flex flex-col gap-8">
    <div class="w-full rounded-2xl border border-amber-a5 bg-amber-a2 p-5 flex items-start gap-4 shadow-2xs">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-a4 text-amber-11">
        <span class="material-icons text-xl">warning</span>
      </div>
      <div>
        <h3 class="text-base font-bold text-amber-12">Aucun abonnement actif</h3>
        <p class="mt-1 text-sm text-neutral-11 whitespace-normal leading-relaxed">
          Vous n'avez actuellement aucun abonnement actif. Choisissez l'une des offres ci-dessous pour
          débloquer l'accès complet aux outils de gestion immobilière de Pyzou.
        </p>
      </div>
    </div>

    <!-- Stripe Pricing Table component -->
    <div class="border border-neutral-a4 rounded-2xl p-4 sm:p-6 bg-neutral-1 shadow-sm">
      <aura-stripe-pricing-table></aura-stripe-pricing-table>
    </div>

    @if (history().length > 0) {
      <aura-user-subscription-history
        [history]="history()"
        [loading]="loadingHistory()"
        [loadingMore]="loadingMore()"
        [hasMore]="hasMore()"
        [total]="total()"
        (loadMore)="loadMoreHistory()"
      />
    }
  </div>
}
